export default __webpack_public_path__ + "static/media/3.f788a976.jpg";